import { motion } from "framer-motion";
import { Button } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { startRecordingThunk } from "../../redux/features/screenRecordingSlice";

export const ScreenRecordingLeft = () => {
  const dispatch = useDispatch();
  const recordingStatus = useSelector(
    (state) => state.screenRecording.recordingStatus
  );
  const handleStartRecording = async () => {
    try {
      await dispatch(startRecordingThunk());
      // ... handle successful recording start
    } catch (err) {
      // ... handle recording start error
    }
  };

  return (
    <div className="flex flex-col justify-center items-center">
      <motion.div
        className="z-10"
        transition={{ ease: "linear", duration: 0.5 }}
        initial={{ scale: 1.6 }}
        animate={{ scale: 0.8 }}
      >
        <img
          src="/img/recordingIcon.png"
          alt="screenRecordingIcon"
          width="160px"
        />
      </motion.div>

      <motion.div
        transition={{ ease: "linear", duration: 0.5 }}
        initial={{ scale: 0, y: 0 }}
        animate={{ scale: 1, y: "-10px" }}
      >
        <div className="flex it{ems-center justify-center">
          <Button
            version="primary"
            text="Start Recording"
            width="fit-content"
            handleClick={handleStartRecording}
            disabled={recordingStatus === "recording"}
          />
        </div>
      </motion.div>
    </div>
  );
};
